import * as accounts from '@journeyapps-platform/types-accounts';
import { Routes } from '@journeyapps-platform/types-accounts';
import * as sdk from '@journeyapps-labs/common-sdk';
import { METHOD } from '@journeyapps-labs/common-sdk';

export class AccountsPortalClient<C extends sdk.NetworkClient = sdk.NetworkClient> extends sdk.SDKClient<C> {
  constructor(options: sdk.SDKClientOptions<C>) {
    super({
      ...options,
      endpoint: options.endpoint || 'https://accounts.journeyapps.com',
      client: options.client.augment({
        timeout: 10000
      }) as C
    });
  }

  sendOTP = this.createEndpoint<accounts.SendSignupVerificationParams, void>({
    path: Routes.SEND_OTP,
    method: METHOD.POST
  });

  verifyOTP = this.createEndpoint<accounts.DoSignupVerificationParams, void>({
    path: Routes.VERIFY_OTP,
    method: METHOD.POST
  });

  verifyReCaptcha = this.createEndpoint<accounts.ReCaptchaVerificationParams, void>({
    path: Routes.VERIFY_CAPTCHA,
    method: METHOD.POST
  });

  startEmailSignupWorkflow = this.createEndpoint<accounts.StartEmailSignupRequest, accounts.StartEmailSignupResponse>({
    path: Routes.START_EMAIL_SIGNUP,
    method: METHOD.POST
  });

  completeSignup = this.createEndpoint<accounts.CompleteSignupParams, accounts.CompleteSignupResponse>({
    path: Routes.COMPLETE_SIGNUP,
    method: METHOD.POST
  });

  issueAccountsHubToken = this.createEndpoint<void, accounts.TokenResponse>({
    path: Routes.ISSUE_ACCOUNTS_HUB_TOKEN,
    method: METHOD.GET,
    retryable: true
  });

  upgradeToEnterprise = this.createEndpoint<void, accounts.TokenResponse>({
    path: Routes.UPGRADE_TO_ENTERPRISE,
    method: METHOD.POST
  });

  issueDeveloperToken = this.createEndpoint<accounts.IssueDeveloperTokenParams, accounts.TokenResponse>((appId) => {
    return {
      path: Routes.ISSUE_DEVELOPER_TOKEN,
      method: METHOD.POST,
      retryable: true
    };
  });

  updateDetails = this.createEndpoint<accounts.UpdateDetailsRequest, void>((appId) => {
    return {
      path: Routes.UPDATE_USER_DETAILS,
      method: METHOD.POST,
      retryable: true
    };
  });

  logout = this.createEndpoint<void, void>({
    path: Routes.LOGOUT,
    method: METHOD.POST
  });
}
